var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"studentRegister page-padding"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('route.studentRegister')))]),_c('div',{staticClass:"register-main"},[_c('student-form-info')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }